import { Theme, Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import Logo from "../components/Logo";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import {
  navigateToNext,
  NavigateToNext,
  setLanguage,
  SetLanguage,
  setUserValue,
  SetUserValue
} from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface ILanguageDispatchProps {
  onNavigateToNext: NavigateToNext;
  onSetLanguage: SetLanguage;
  onSetUserValue: SetUserValue;
}

type LanguageOwnProps = RouteComponentProps;

interface ILanguageStateProps {
  languageStrings: IStrings;
  theme: Theme.Props;
  user: Users.User;
}

type LanguageProps = ILanguageDispatchProps &
  LanguageOwnProps &
  ILanguageStateProps;

const LanguageContainer = styled(Container)`
  grid-template-rows: 20vh 55vh 25vh;
`;

class Language extends React.Component<LanguageProps> {
  public handleEnter = (language: Users.Language) => {
    const { onNavigateToNext, onSetLanguage, onSetUserValue } = this.props;

    onSetUserValue({ name: "language", value: language });
    onSetLanguage(language);

    onNavigateToNext();
  };

  public render() {
    const {
      languageStrings: strings,
      theme: { colors, logo }
    } = this.props;

    return (
      <ErrorBoundary>
        <LanguageContainer>
          <Row align="center" justify="center">
            <Logo logo={logo} />
          </Row>
          <Column align="center" justify="space-around">
            <Title color={colors.secondary} size="3rem">
              {strings.languageHeader}
            </Title>
            <Row align="center" justify="center">
              <Button
                bg={colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("eng")}
              >
                English
              </Button>
              <Button
                bg={colors.success}
                size="2.5rem"
                onClick={() => this.handleEnter("esp")}
              >
                Español
              </Button>
            </Row>
          </Column>
          <Row align="center" justify="center">
            <ResetButton />
          </Row>
        </LanguageContainer>
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = ({
  router: { languageStrings },
  theme,
  user
}: IState) => ({
  languageStrings,
  theme,
  user
});

const mapDispatchToProps = {
  onNavigateToNext: navigateToNext,
  onSetLanguage: setLanguage,
  onSetUserValue: setUserValue
};

export default connect<ILanguageStateProps, ILanguageDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(Language);



// WEBPACK FOOTER //
// ./src/views/Language.tsx